"use strict";

require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.function.name.js");
var _searchtabular = require("@evidation-shared/searchtabular");
var _lodash = require("lodash");
var _react = _interopRequireDefault(require("react"));
var CellSpan = function CellSpan(props) {
  var headerProps = props.column;
  if ((0, _lodash.includes)(Object.keys(props.customCells), props.column.name)) {
    var renderProps = {
      rowData: props.row.rowData,
      value: props.row.rowData[props.column.name]
    };
    return /*#__PURE__*/_react["default"].createElement("span", null, props.customCells[props.column.name](renderProps));
  }
  var href = props.row['rowData'][headerProps.href_field];
  var target = props.row['rowData'][headerProps.target] || "_blank";
  var linkClass = props.row['rowData'][headerProps.link_icon];
  var className = 'cell-left';
  if ((0, _lodash.includes)(['number', 'date'], headerProps.content_type)) {
    className = 'cell-right';
  }
  var value = props.value;
  if (typeof value === 'boolean') {
    value = value ? 'Yes' : 'No';
  }
  if (href) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: className
    }, /*#__PURE__*/_react["default"].createElement("a", {
      target: target,
      href: href,
      className: linkClass
    }, (0, _searchtabular.highlightCell)(value, props.row)));
  }
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: className
  }, (0, _searchtabular.highlightCell)(value, props.row));
};
var _default = exports["default"] = CellSpan;